/**
 * Shown for paths that belonged to the hosted product surface (accounts, the
 * app, chat, billing, invites). Explains the closure and points to pm-skills.
 */
import { Link } from 'react-router-dom';

import { SiteLayout } from '@/components/SiteLayout';
import { Button } from '@/components/ui';
import { GITHUB_URL, RETIRED_WHEN, SUPPORT_EMAIL } from '@/config/site';

export const RetiredRoute = () => (
  <SiteLayout>
    <section className="px-6 py-16 md:py-24">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="font-serif text-3xl font-semibold text-text-primary md:text-4xl">
          This part of Kaibernetic has closed
        </h1>
        <p className="mt-6 text-lg text-text-secondary">
          The hosted service — accounts, the web app and the chat assistant — was retired in{' '}
          {RETIRED_WHEN}. The project-management skills behind it live on GitHub as pm-skills, and
          the blog is still here.
        </p>
        <p className="mt-4 text-sm text-text-secondary">
          Had an account? Your data was exported before the shutdown. Email{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-text-primary">
            {SUPPORT_EMAIL}
          </a>{' '}
          for a copy.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a href={GITHUB_URL} target="_blank" rel="noreferrer" aria-label="pm-skills on GitHub">
            <Button className="px-8 py-3 text-base">pm-skills on GitHub</Button>
          </a>
          <Link to="/blog" aria-label="Read the Kaibernetic blog">
            <Button variant="secondary" className="px-8 py-3 text-base">
              Read the blog
            </Button>
          </Link>
        </div>
      </div>
    </section>
  </SiteLayout>
);
